export const socialsData = {
    github: 'https://github.com/sudhanshu7352',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/sudhanshu-kumar-b7830322b/',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/Sudhans07757035',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}